import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "mapElement",
  class: "relative h-full w-full"
}
const _hoisted_2 = {
  class: "h-full w-full",
  ref: "manual"
}
const _hoisted_3 = { ref: "topLeft" }
const _hoisted_4 = { class: "flex flex-col shadow-lg" }
const _hoisted_5 = { ref: "topRight" }
const _hoisted_6 = { ref: "bottomLeft" }
const _hoisted_7 = { ref: "bottomRight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "manual")
    ], 512),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "top-left", {}, () => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            title: "Zoom in",
            class: "p-2 bg-white border border-b rounded-t rounded-b-none border-fog-900 focus:outline-none focus:shadow-outline",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incrementZoom && _ctx.incrementZoom(...args)))
          }, [
            _createVNode(_component_Icon, {
              type: "solid",
              name: "plus",
              class: "w-4 h-4"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            title: "Zoom out",
            class: "p-2 bg-white border border-t rounded-b rounded-t-none border-fog-900",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decrementZoom && _ctx.decrementZoom(...args)))
          }, [
            _createVNode(_component_Icon, {
              type: "solid",
              name: "minus",
              class: "w-4 h-4"
            })
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "top-right")
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "bottom-left")
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "bottom-right")
    ], 512)
  ]))
}